export const neutralColor = {
  0: '#ffffff',
  50: '#fafbff',
  75: '#f9fafc',
  100: '#f4f6fa',
  200: '#edeff5',
  300: '#e6e8f0',
  400: '#d8dae5',
  500: '#c1c4d6',
  600: '#8f95b2',
  700: '#696f8c',
  800: '#474d66',
  900: '#252836',
  950: '#1a1d26',
  1000: '#000000',
};

// Change these to your company's brand colors.
//     1. `main` is the only color necessary, but all the
//   other ones are recomended.
//     2. `highlight` is advised be way lighter the the
//   `lighter` counterpart.
//     3. `lowlight` is advised be way darker the the
//   `darker` counterpart.
//     4. Its nice if you can match colors from one group
//   as contrast color for another, but its not always
//   possible given the palette.
export const brandColors = {
  // Samax Purple
  primary: {
    lowlight: '#0e011d',
    darker: '#2d0859',
    dark: '#3d0b7d',
    main: '#4e0ea1',
    light: '#6412ce',
    lighter: '#8231ed',
    highlight: '#f5edff',
    contrastText: '#f5edff', // same as primary highlight
    buttonHover: '#6412ce', // same as primary light
  },
  // Samax Green
  secondary: {
    lowlight: '#fae54b',
    darker: '#fae54b',
    dark: '#fae54b',
    main: '#fae54b',
    light: '#fae54b',
    lighter: '#fae54b',
    highlight: '#fae54b',
    contrastText: '#1a1d26', // same as secondary lowlight
    buttonHover: '#fae54b', // same as secondary dark
  },
  // Samax Orange
  terciary: {
    lowlight: '#301700',
    darker: '#994d00',
    dark: '#e07000',
    main: '#ff8000',
    light: '#ff9933',
    lighter: '#ffb366',
    highlight: '#fff4e6',
    contrastText: '#301700', // same as terciary lowlight
    buttonHover: '#e07000', // same as terciary dark
  },
};

export const commonColors = {
  blue: {
    dark: '#0f3699',
    regular: '#083fcf',
    light: '#2b62f3',
    highlight: '#e4ecff',
    darkerHighlight: '#cddbff',
    contrastText: '#e4ecff',
  },
  green: {
    dark: '#088a59',
    regular: '#17ae75',
    light: '#41d19b',
    highlight: '#eef8f4',
    darkerHighlight: '#dcf2ea',
    contrastText: '#eef8f4',
  },
  red: {
    dark: '#a70f0f',
    regular: '#da2424',
    light: '#f05252',
    highlight: '#f9dada',
    darkerHighlight: '#f4b6b6',
    contrastText: '#f9dada',
  },
  yellow: {
    dark: '#ed9419',
    regular: '#f6b941',
    light: '#f8c74e',
    highlight: '#ffefd2',
    darkerHighlight: '#ffdfa6',
    contrastText: '#ffefd2',
  },
  orange: {
    dark: '#ec6226',
    regular: '#f67741',
    light: '#f78758',
    highlight: '#f9e5da',
    darkerHighlight: '#f2d5c4',
    contrastText: '#f9e5da',
  },
  purple: {
    dark: '#5b02b4',
    regular: '#6c08cf',
    light: '#801de3',
    highlight: '#f1e4ff',
    darkerHighlight: '#e3ccfc',
    contrastText: '#f1e4ff',
  },
};

export const progressColors = {
  0: '#f62e44',
  126: '#f65046',
  251: '#f77649',
  376: '#fb8d33',
  501: '#ffa41c',
  626: '#c4b11f',
  751: '#84bf23',
  876: '#4eae37',
  1000: '#169c4c',
};

export const colorTokens = {
  border: {
    default: neutralColor[400],
    light: neutralColor[200],
  },
  white: neutralColor[0],
  black: neutralColor[1000],
  icon: neutralColor[800],
  brandPrimary: brandColors.primary.main,
  brandPrimaryHighlight: neutralColor[200],
  body: {
    background: neutralColor[100],
    containerDivLight: neutralColor[200],
    containerDivDark: neutralColor[300],
    placeholder: neutralColor[400],
  },
  button: {
    disabled: {
      background: neutralColor[400],
      text: neutralColor[700],
    },
  },
  textInput: {
    background: neutralColor[0],
    border: neutralColor[400],
    textFilled: neutralColor[1000],
    textPlaceholder: neutralColor[600],
  },
  sidePanel: {
    background: neutralColor[200],
  },
  text: {
    primary: neutralColor[0],
    secondary: neutralColor[0],
  },
};

// Chart color palettes for semantic color assignment
export const chartColorPalettes = {
  evaluative: [
    ...Object.entries(progressColors)
      .sort((a, b) => parseInt(b[0]) - parseInt(a[0]))
      .map(([_key, value]) => value),
    '#FF4D4F', // Red
  ],

  // This shouldn't be declared this way. It should use primary color and
  // change opacity in the component where this is being used. Since
  // the glassdoor feature is temporary, I'll leave this here.
  neutral: [
    'rgba(78, 14, 161, 1)', // 100% opacity
    'rgba(78, 14, 161, 0.91)', // 94% opacity
    'rgba(78, 14, 161, 0.82)', // 88% opacity
    'rgba(78, 14, 161, 0.73)', // 82% opacity
    'rgba(78, 14, 161, 0.64)', // 76% opacity
    'rgba(78, 14, 161, 0.55)', // 70% opacity
    'rgba(78, 14, 161, 0.46)', // 64% opacity
    'rgba(78, 14, 161, 0.37)', // 58% opacity
    'rgba(78, 14, 161, 0.28)', // 52% opacity
    'rgba(78, 14, 161, 0.19)', // 45% opacity
  ],
};